module.exports = __webpack_public_path__ + "img/stores_virtuell_appointment@1x.c4ae929.jpg";